var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var d3 = require('d3');

function IndexConceptsImpact(el) {
    var $el = $(el),
        metaData = JSON.parse($el.attr('data-metadata')),
        impactData = JSON.parse($el.attr('data-chart')),
        chartDiv = '#impact-chart-'+metaData['concept_slug'],
        conceptName = metaData['concept_name'],
        conceptSlug = metaData['concept_slug'],
        benchmarkName = metaData['benchmark_name'];

    var width = 1100,
        height = 650,
        margin = { top: 10, right: 10, bottom: 10, left: 10 },
        radius = Math.min(width, height) / 3.5;

    var arc = d3.arc()
        .outerRadius(radius * 0.7)
        .innerRadius(radius * 0.6);

    var outerArc = d3.arc()
         .outerRadius(radius * 1.5)
         .innerRadius(radius * 1.5);

    var pie = d3.pie()
        .value(function(d) { return d.value; })
        .sort(null);

    var svg = d3.select(chartDiv).append("div")
        .classed("svg-container", true)
    .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("viewBox", "0 0 " + (width + margin.right + margin.left) + " " + (height + margin.bottom + margin.top))
        .classed("svg-content-responsive", true)
    .append("g")
        .attr("transform", "translate(" + ((width+ margin.right +margin.left)/2) + "," + ((height + margin.top + margin.bottom)/2) + ")");

    var centerText = svg.append("foreignObject")
        .attr('id', 'center-text-'+conceptName)
        .attr("width", 180)
        .attr("height", radius)
        .attr("y", -85)
        .attr("x", -180/2)
        .html('<div class="align-center" style="line-height:1.2; width: 180px; height: 180px; display: flex; justify-content: center; align-content: center; flex-direction:column;">'+
            '<span style="font-size:1.15rem; color:#4a4a4a;">As compared to the '+benchmarkName+', <br><span style="font-size:1.75rem; font-family: FFDINStdCondensedBold; color:#1a59c4;;">'+conceptName.toUpperCase()+':</span>')
        
    svg.append('g').attr('class', 'slices');
    svg.append('g').attr('class', 'lines');
    svg.append('g').attr('class', 'cards');

    var path = svg.select(".slices").selectAll("path")
        .data(pie(impactData))
    .enter().append("path")
        .attr("class", "slice")
        .attr('d', arc)
        .attr("fill", "#1a59c4")
        .attr("stroke", "none")

    var polyline = svg.select(".lines").selectAll("polyline")
        .data(pie(impactData))
    .enter().append("polyline")
        .attr("points", function(d) {
            var pos = outerArc.centroid(d);
            pos[0] = radius * 1.2* (midAngle(d) < Math.PI ? 1 : -1);
            return [arc.centroid(d), outerArc.centroid(d), pos]
        })
        .attr("fill", "none")
        .attr("stroke", "#1a59c4")
        .attr("stroke-width", "2px")

    var card = svg.select(".cards").selectAll("text")
        .data(pie(impactData))
   .enter().append("foreignObject")
        .attr("width", 300)
        .attr("height", 100)
        .attr("dy", ".35em")
        .attr("transform", function(d) {
            var pos = outerArc.centroid(d);
            pos[0] = radius * 1.4 * (midAngle(d) < Math.PI ? 1 : -2.15);
            return "translate(" + pos + ")"
        })
       .attr("x", function(d, i) {
            return ((i == 0 || i == 4) ? -100 : (i == 1 || i ==  3) ? -50 : (i == 5 || i == 9) ? 100 : (i == 6 || i == 8) ? 50 : 0);
        })
       .attr("y", function(d, i) { 
            return ((i == 1 || i == 8) ? -25 : (i == 3 || i == 6) ? -75 : -50)
        })
       .style("fill", "#fff")
       .html(function(d) {
            return '<div class="impact-stat-card align-left" style="background-color:#fff; border:solid 3px #1a59c4; width:300px; height:100px; color:#1a59c4; padding:0.5rem;">'+
                        '<div id="'+d.data['slug']+conceptSlug+'-modal-button" class="modal-open" style="font-size:0.9rem; line-height:1; cursor:pointer;">' +
                            d.data['name'] + '<span style="color:#3FA90D; font-family: FFDINStdBold;">&nbsp> </span>'+
                            '<hr style="border: none; border-top: 1px dotted #1a59c4; color: #1a59c4; background-color: #fff;">' +
                        '</div>'+
                        '<div style="font-size:1.25rem; line-height:1; font-family: FFDINStdCondensedMedium;">' +
                            '<span style="color:#4a4a4a;">' + d.data['statement_verb'] + '</span> ' +
                            '<span style="color:' +
                            ((d.data['calculation_type'] == 'Ratio Reverse') && (+d.data['stat_value'] >= +d.data['threshold_value']) ? '#AE0808' : (d.data['calculation_type'] == 'Ratio Reverse')&& (+d.data['stat_value'] < +d.data['threshold_value']) ? '#51A515' : (+d.data['stat_value'] >= +d.data['threshold_value']) ? '#51A515' : '#AE0808') +
                            '; font-family: FFDINStdBold;">' +
                                ( ((d.data['calculation_type'] == 'Ratio' || d.data['calculation_type'] == 'Ratio Reverse')&& (+d.data['stat_value'] >= +d.data['threshold_value'])) ? ((+d.data['stat_value'] - 1) * 100).toFixed(1) + '% ' : ((d.data['calculation_type'] == 'Ratio' || d.data['calculation_type'] == 'Ratio Reverse')&& (+d.data['stat_value'] < +d.data['threshold_value'])) ? ((1 - +d.data['stat_value']) * 100).toFixed(1) + '% ' : (d.data['calculation_type'] == 'Difference') ? (Math.abs(+d.data['stat_value'] * 100)).toFixed(1) + '% ' : '' ) +
                            '</span>' +
                            '<span style="color:#4a4a4a;">'+ 
                                ((d.data['calculation_type'] == 'Ratio Reverse') && (+d.data['stat_value'] >= +d.data['threshold_value']) ? d.data['impact_description_neg'] : (d.data['calculation_type'] == 'Ratio Reverse') && (+d.data['stat_value'] < +d.data['threshold_value']) ? d.data['impact_description_pos'] : (+d.data['stat_value'] >= +d.data['threshold_value']) ? d.data['impact_description_pos'] : d.data['impact_description_neg']) + 
                            '</span>' +
                        '</div>' +
                    '</div>'
        })

    impactData.forEach(function(d) {
        $(chartDiv).append('<div id="'+d.slug+conceptSlug+'-modal" class="modal">'+
                                '<div class="modal-content">'+
                                    '<span class="close">&times;</span>' +
                                    '<h2 class="align-center" style="font-size:2.18rem; color: #1a59c4;">'+
                                        d['name']+
                                    '</h2>' + 
                                    '<hr style="border: none; border-top: 1px solid #A0A0A0; color: #4a4a4a; background-color: #fff;">' +
                                    '<p style="font-size:1.125rem;" class="align-left">' + d['data_description'] + '</p>' +
                                '</div>' +
                            '</div>');
    })

    $('.modal-open').on('click', function(e) {
        var id =$(this).attr('id');
        id = id.split('-');
        var newID = id[0]+'-'+id[1];
        console.log(newID);
        $('#'+newID).css('display','block');
    })

    $('.close').on('click', function(e) {
        $('.modal').css('display','none');
    })


    function midAngle(d) {
        return d.startAngle + (d.endAngle - d.startAngle)/2;
    }

}

module.exports = IndexConceptsImpact;

